import specialities from './sections/specialities';
import megamenu from './sections/megamenu';
import readMore from './sections/read-more';
import counter from './animations/counter';
import milestoneAnimation from './animations/milestone';
import specialitiesAnimation from './animations/specialities';

document.addEventListener('DOMContentLoaded', () => {
	megamenu.init();
	readMore.init();
	specialities.initDesktop();
	specialities.initMobile();
	specialities.finalize();
	milestoneAnimation.init();
	specialitiesAnimation.init();
	counter.init();
});

import { Application } from "@hotwired/stimulus"
import { definitionsFromContext } from "@hotwired/stimulus-webpack-helpers"

window.Stimulus = Application.start()
// window.Stimulus.debug = true
const context = require.context("./controllers", true, /\.js$/)
Stimulus.load(definitionsFromContext(context))
